import React, {FC} from 'react';
import styled from 'styled-components';

import {Dropdown, DropdownProps} from '../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {ColorPicker, ColorPickerProps} from './colorPicker';

/*
 * Props.
 */

export type ColorPickerDropdownProps = ColorPickerProps & DropdownProps;

/*
 * Style.
 */

const StyledPickerDiv = styled.div`
  padding: 12px;
`;

/*
 * Component.
 */

export const ColorPickerDropdown: FC<ColorPickerDropdownProps> = (props) => (
  <Dropdown {...props}>
    <StyledPickerDiv>
      <ColorPicker {...props} />
    </StyledPickerDiv>
  </Dropdown>
);
